import { Global } from '@emotion/react';
import { Button } from 'antd';
import axios from 'axios';
import React, {
  createContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import ErrorBoundary from '@/components/UI/ErrorBoundary';
import MobileHome from '@/pages/_Mobile/MobileHome';

import client from '../../lib/feathers';
import AutoLockerNotification from './components/AutoLockerNotification';
import MobileHeader from './components/MobileHeader';
import StandbyScreen from './components/StandbyScreen';
import { getMobileLayoutClassName } from './helpers';
import styles from './MobileLayout.module.scss';
import { globalStyles } from './styles';
import { useStandby } from './useStandby.hooks';

export const PopupContext = createContext({
  showPopup: undefined,
  setShowPopup: (cb) => {
    console.log({ cb });
  },
});

export const LifeServiceContext = createContext({
  showBackButton: false,
  setShowBackButton: (_isShowButton) => {},
  currentLifeServicePage: undefined,
  setCurrentLifeServicePage: (_pageName) => {},
});

const MobileLayout = (props) => {
  const [msgData, setMsgData] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [packageInfo, setPackageInfo] = useState({});
  const [openDoor, setOpenDoor] = useState(false);
  const [time, setTime] = useState(10);
  const [urgent, setUrgent] = useState({});
  const [urgentPopup, setUrgentPopup] = useState(false);
  const [showBackButton, setShowBackButton] = useState(false);
  const [currentLifeServicePage, setCurrentLifeServicePage] = useState();

  if (window.location.href.indexOf('&t=') >= 0) {
    localStorage.setItem('feathers-jwt', window.location.href.split('&t=')[1]);
  }
  const MobileContentRef = useRef(null);

  useEffect(() => {
    if (MobileContentRef.current) {
      MobileContentRef.current.scrollTop = 0;
    }
  }, [props, props.location.pathname]);

  useEffect(() => {
    (async () => {
      try {
        const data = await client.reAuthenticate();
        const show = data.user.allow.find((i) => i.name === '送件服務');
        if (show) {
          client.io.on('robotStatus', (arr, callback) => {
            console.log('robotStatus msg:', arr);
            if (arr.position === 'household') {
              if (arr.householdNumber === data.user.householdNumbers[0])
                setShowAlert(arr.task !== 'closeDoor');
              setPackageInfo(arr.package);
              callback('success');
            }
          });
        }
        if (data.user.keyboardAccount === '物業keyboard帳號') {
          client.io.on('baEvent', (arr) => {
            console.log(arr);
            setUrgent(arr);
            setUrgentPopup(true);
            setTimeout(() => {
              setUrgentPopup(false);
            }, arr?.urgentTime);
          });
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, []);
  useEffect(() => {
    if (openDoor === true) {
      const RobotTime = setInterval(() => {
        console.log('hi');
        setTime((pre) => pre - 1);
        clearInterval(RobotTime);
      }, 1000);
    }
    if (time === 0) {
      setShowAlert(false);
      setTime(10);
    }
  }, [openDoor, time]);

  const [canActiveScreenStandby, isStandby, displayTime, screenWakeUp] =
    useStandby();

  const popupContextValue = useMemo(
    () => ({ showPopup, setShowPopup }),
    [showPopup, setShowPopup]
  );

  const lifeServiceContextValue = useMemo(
    () => ({
      showBackButton,
      setShowBackButton,
      currentLifeServicePage,
      setCurrentLifeServicePage,
    }),
    [
      showBackButton,
      setShowBackButton,
      currentLifeServicePage,
      setCurrentLifeServicePage,
    ]
  );

  return (
    <PopupContext.Provider value={popupContextValue}>
      <LifeServiceContext.Provider value={lifeServiceContextValue}>
        <Global styles={globalStyles} />
        <AutoLockerNotification />
        {canActiveScreenStandby && isStandby ? (
          <StandbyScreen
            displayTime={displayTime}
            screenWakeUp={screenWakeUp}
          />
        ) : (
          <div
            className={getMobileLayoutClassName(
              canActiveScreenStandby,
              isStandby
            )}
          >
            <MobileHeader
              setMsgData={(key) => {
                setMsgData(key);
              }}
              pathname={props.location.pathname}
            />
            {props.location.pathname === '/mobile/home' ? (
              <div className={styles.MobileContent} ref={MobileContentRef}>
                <MobileHome msgDatas={msgData} />
              </div>
            ) : (
              <div className={styles.MobileContent} ref={MobileContentRef}>
                <ErrorBoundary>{props.children}</ErrorBoundary>
              </div>
            )}
          </div>
        )}
        {/* 機器人派送 */}
        <div
          className={styles.BasicLayoutAlert}
          style={{
            display: showAlert ? 'flex' : 'none',
            alignItems: showAlert && 'center',
            justifyContent: showAlert && 'center',
          }}
        >
          <div className={styles.BasicLayoutContainer}>
            {openDoor === true ? (
              <>
                <p> 剩餘</p>
                <div style={{ fontSize: '15vw', margin: '20px 0px' }}>
                  {time}
                </div>
                <p>秒</p>
                <p>機器人即將關門...</p>
              </>
            ) : (
              <>
                <img
                  src="img/robot_one.svg"
                  alt="圖片"
                  className={styles.robotImg}
                />
                <p>{packageInfo.household}住戶</p>
                <p>{packageInfo?.packageType ? '郵件包裹' : '寄物'}已送達</p>
                <p>請按開門按鈕</p>
                <p>機器人即將開啟1號艙</p>
                <Button
                  className={styles.robotBtn}
                  onClick={() => {
                    setTimeout(() => {
                      setOpenDoor(true);
                    }, 4000);
                    axios.post(
                      '/ezcon/api/robot/openGate',
                      {
                        packageInfo,
                      },
                      {
                        headers: {
                          authorization: localStorage.getItem('feathers-jwt'),
                        },
                      }
                    );
                  }}
                >
                  開門
                </Button>
              </>
            )}
          </div>
        </div>
        {/* 緊急訊息 */}
        <div
          className={styles.BasicLayoutAlert}
          style={{
            display: urgentPopup ? 'flex' : 'none',
            alignItems: urgentPopup && 'center',
            justifyContent: urgentPopup && 'center',
            background: 'rgba(0, 0, 0,0.9)',
          }}
          onClick={() => setUrgentPopup(false)}
        >
          <marquee direction="left" width="100%">
            <div style={{ fontSize: '4.5vw' }}>{urgent?.text}</div>
          </marquee>
        </div>
      </LifeServiceContext.Provider>
    </PopupContext.Provider>
  );
};
export default MobileLayout;
